import type { LucideIcon } from 'lucide-react';
import React from 'react';

import { ctw } from '@/common';
import { Card, CardContent, CardHeader } from '@/components';
import { QuestionMarkTooltip } from '../../primitives';

type ReportCardProps = {
  title?: React.ReactNode;
  children: React.ReactNode;
  tooltip?: string;
  Icon?: LucideIcon;
  showTooltip?: boolean;
  headerAction?: React.ReactNode;
  className?: string;
  contentClassName?: string;
};

export const ReportCard: React.FC<ReportCardProps> = ({
  title,
  children,
  tooltip,
  Icon,
  showTooltip = true,
  headerAction,
  className,
  contentClassName,
}) => {
  return (
    <Card className={ctw('mb-6 rounded-3xl bg-white', className)}>
      {title && (
        <CardHeader className="flex flex-row items-center justify-between px-10 pb-4 pt-10">
          <div className="flex items-center gap-2">
            {Icon && <Icon className="h-5 w-5 text-slate-600" />}
            <h2 className="text-xl font-semibold" style={{ color: '#14203D' }}>
              {title}
            </h2>
            {tooltip && showTooltip && <QuestionMarkTooltip text={tooltip} className="ml-1" />}
          </div>
          {headerAction && <div>{headerAction}</div>}
        </CardHeader>
      )}
      <CardContent className={ctw('px-10 pb-10 pt-0', contentClassName)}>{children}</CardContent>
    </Card>
  );
};
